var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var validate = require('../../node_modules/jquery-validation/dist/jquery.validate.js');

var OrderForm = function () {
    this.$orderForm = $('.module-order-form .order-form-modular');
    this.$termsErrorLabel = $('.module-order-form .order-form-modular .terms-error-label');
};


OrderForm.prototype.init = function () {
    var self = this;
    self.$orderForm.validate({
        errorPlacement: function (error, element) {
            if (element.attr('name') === 'terms') {
                error.appendTo(self.$termsErrorLabel);
            }
        }
    });
    $(self.$orderForm).on('submit', function (e) {
        e.preventDefault();

        if (self.$orderForm.valid()) {

            var data = $(this).serialize();

            $.ajax({
                method: "GET",
                url: NORVITAL.root + 'norvital/v1/order',
                dataType: 'json',
                data: data,
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('X-WP-Nonce', NORVITAL.nonce);
                    self.$orderForm.find('input[type="submit"]').prop('disabled', true); // disable button
                },
                success: function (response) {
                    if (response.redirect) {
                        window.location.href = response.redirect;
                        return;
                    }

                    self.$orderForm.find('.message').html('Your order has been successfully submitted.');
                    self.$orderForm.find('.callout').addClass('success').fadeIn();
                },
                error: function (response) {
                    self.$orderForm.find('.message').html('There was an error creating your order. Please try again.');
                    self.$orderForm.find('.callout').addClass('warning').fadeIn();
                }

            });

        }

    });
};

OrderForm.prototype.addCustomValidations = function() {
    $(this).find("input[digits]").rules("add", "digits"); // Any input with an attribute called "digits", should contain only digits.

    jQuery.validator.addMethod("noAtCharacter", function (value, element) {
        return !(/\@/.test(value));
    });

    $(this).find('input:not([type="email"])').rules("add", "notAtCharacter");

};

module.exports = new OrderForm();
